import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';

export const getCutOffState = createSelector(getRmsSpecificationPage, state => state.cutOffState);

export const getIsCutOffLoading = createSelector(getCutOffState, state => state.loading);

export const getCutOff = createSelector(getCutOffState, state => state.cutOff);


// Cutoff Temperature

export const getCutOffTemperatureState = createSelector(getRmsSpecificationPage, state => state.cutOffTemperatureState);

export const getIsTemperatureControl = createSelector(getCutOffTemperatureState, state => state.isTemperatureControl);
export const getCutOffTemperature = createSelector(getCutOffTemperatureState, state => state.cutOff);

